import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';

export interface DiaSequenciaCheckIn {
    dia: number;
    status: 'done' | 'today' | 'upcoming';
}

@Component({
    selector: 'app-mm-check-in',
    templateUrl: './mm-check-in.component.html',
    styleUrls: ['./mm-check-in.component.scss'],
})
export class MmCheckInComponent implements OnChanges {

    @Input() selo: string = 'BLACK FRIDAY';
    @Input() bilhetes: number = 0;
    @Input() totalDias: number = 7;
    @Input() diasConsecutivos: number = 0;
    @Input() pontosBonus: number = 20;
    @Input() checkInFeitoHoje: boolean = false;
    @Input() custoBilhetePontos: number = 20;
    @Input() premioDestaque: string = 'iPhone 17';
    @Input() requestInProgress: boolean = false;
    @Input() saldoPontos: number = 0;

    @Output() touchCheckIn = new EventEmitter<void>();
    @Output() touchJogarRaspadinha = new EventEmitter<void>();
    @Output() touchConfirmarCompraBilhete = new EventEmitter<void>();
    @Output() touchContinuarSequenciaCompleta = new EventEmitter<void>();

    diasSequencia: DiaSequenciaCheckIn[] = [];
    faltamParaBonus: number = 0;
    isOpenComprarBilhete: boolean = false;
    isOpenSequenciaCompleta: boolean = false;

    private diasConsecutivosAnterior: number | undefined;

    ngOnChanges(): void {
        this.montarDiasSequencia();
        this.faltamParaBonus = Math.max(this.totalDias - this.diasConsecutivos, 0);
        this.verificarSequenciaCompleta();
    }

    private verificarSequenciaCompleta(): void {
        const atingiuAgora = this.diasConsecutivosAnterior !== undefined
            && this.diasConsecutivosAnterior < this.totalDias
            && this.diasConsecutivos >= this.totalDias;

        if (atingiuAgora) {
            this.isOpenSequenciaCompleta = true;
        }

        this.diasConsecutivosAnterior = this.diasConsecutivos;
    }

    private montarDiasSequencia(): void {
        const dias: DiaSequenciaCheckIn[] = [];

        for (let dia = 1; dia <= this.totalDias; dia++) {
            let status: DiaSequenciaCheckIn['status'] = 'upcoming';

            if (dia <= this.diasConsecutivos) {
                status = 'done';
            } else if (dia === this.diasConsecutivos + 1) {
                status = 'today';
            }

            dias.push({ dia, status });
        }

        this.diasSequencia = dias;
    }

    onTouchCheckIn(): void {
        if (this.requestInProgress || this.checkInFeitoHoje) return;
        this.touchCheckIn.emit();
    }

    onTouchJogarRaspadinha(): void {
        this.touchJogarRaspadinha.emit();
    }

    onTouchComprarBilhete(): void {
        this.isOpenComprarBilhete = true;
    }

    onTouchCancelarCompra(): void {
        this.isOpenComprarBilhete = false;
    }

    onTouchConfirmarCompra(): void {
        this.isOpenComprarBilhete = false;
        this.touchConfirmarCompraBilhete.emit();
    }

    onTouchContinuarSequenciaCompleta(): void {
        this.isOpenSequenciaCompleta = false;
        this.touchContinuarSequenciaCompleta.emit();
    }

}
